/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { AgenciesListMetadataDto } from './agenciesListMetadataDto';
import type { AgencyDto } from './agencyDto';

export interface AgenciesListResponseDto {
  data: AgencyDto[];
  metadata: AgenciesListMetadataDto;
}
